import { createContext, useCallback, useContext, useMemo, useState } from 'react';

const SidebarSlotContext = createContext(null);

export function SidebarSlotProvider({ children }) {
  const [slot, setSlot] = useState(null);

  const clearSlot = useCallback(() => setSlot(null), []);

  const value = useMemo(() => ({ slot, setSlot, clearSlot }), [slot, clearSlot]);
  return <SidebarSlotContext.Provider value={value}>{children}</SidebarSlotContext.Provider>;
}

export function useSidebarSlot() {
  const ctx = useContext(SidebarSlotContext);
  if (!ctx) {
    throw new Error('useSidebarSlot must be used within SidebarSlotProvider');
  }
  return ctx;
}
